import { Bar } from 'vue-chartjs'

export default {
  name: 'bar-chart',

  mixins: [Bar]
}
